export default "__VITE_ASSET__CzIsg3p1__"